export function SkeletonLoader() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="bg-card grid animate-pulse overflow-hidden shadow-sm"
          style={{ gridTemplateRows: 'auto 1fr auto' }}
        >
          {/* Hero skeleton */}
          <div className="bg-muted aspect-video w-full" />

          {/* Body skeleton */}
          <div className="space-y-3 p-4">
            <div className="bg-muted h-4 w-3/4" />
            <div className="bg-muted h-3 w-1/2" />
            <div className="bg-muted h-3 w-2/3" />
            <div className="bg-muted h-3 w-1/3" />
          </div>

          {/* CTA skeleton */}
          <div className="border-border flex items-center justify-center border-t py-3">
            <div className="bg-muted h-3 w-20" />
          </div>
        </div>
      ))}
    </div>
  );
}
